import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Chip,
  Box,
  Typography,
} from "@mui/material";
import DISTRICTS from "../../../constants/district";
import PROVINCE from "../../../constants/province";

interface ModalAssignDistrictProps {
  open: boolean;
  handleClose: () => void;
  driver: any;
  currentDistricts: string[]; // List of district codes
  onSave: (driverId: string, districtCodes: string[]) => void;
}

const ModalAssignDistrict: React.FC<ModalAssignDistrictProps> = ({
  open,
  handleClose,
  driver,
  currentDistricts,
  onSave,
}) => {
  const [selectedDistricts, setSelectedDistricts] = useState<string[]>(currentDistricts || []);
  const [provinceCode, setProvinceCode] = useState<string>("202"); // Default: Hồ Chí Minh

  // Filter districts belonging to the selected province (e.g. HCM code 202)
  const availableDistricts = DISTRICTS.filter((d: any) => d.province_code === provinceCode);

  const handleChange = (event: any) => {
    const value = event.target.value;
    setSelectedDistricts(typeof value === "string" ? value.split(",") : value);
  };

  const handleRemoveChip = (codeToRemove: string) => {
    setSelectedDistricts((prev) => prev.filter((code) => code !== codeToRemove));
  };

  const handleSave = () => {
    if (driver?.id) {
      onSave(driver.id, selectedDistricts);
    }
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ fontWeight: "bold" }}>
        Phân công khu vực chạy đơn: {driver?.name}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Khi có đơn hàng mới thuộc các quận/huyện được chọn, hệ thống sẽ tự động gán cho tài xế này.
          Bạn vẫn có thể chủ động gán tay sang tài xế khác bất cứ lúc nào nếu cần.
        </Typography>

        <Box style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Tỉnh / Thành phố</InputLabel>
            <Select
              value={provinceCode}
              label="Tỉnh / Thành phố"
              onChange={(e) => setProvinceCode(e.target.value)}
            >
              {PROVINCE.map((p: any) => (
                <MenuItem key={p.code} value={p.code}>
                  {p.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>Quận / Huyện phụ trách</InputLabel>
            <Select
              multiple
              value={selectedDistricts}
              onChange={handleChange}
              input={<OutlinedInput label="Quận / Huyện phụ trách" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((val) => {
                    const item = DISTRICTS.find((d: any) => d.code === val);
                    return (
                      <Chip
                        key={val}
                        label={item ? item.name : val}
                        size="small"
                        onMouseDown={(e) => e.stopPropagation()}
                        onDelete={() => handleRemoveChip(val)}
                      />
                    );
                  })}
                </Box>
              )}
            >
              {availableDistricts.map((d: any) => (
                <MenuItem key={d.code} value={d.code}>
                  {d.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Hủy
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Lưu thiết lập
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAssignDistrict;
